import { createSelector } from 'redux-starter-kit';

const getAppState = state => state.app;

export const getIsAppReady = createSelector(
  [getAppState],
  app => app.ready
);
